<div class="pk-breadcrumbs-wrap d-none d-sm-block" *ngIf="breadcrumbs?.length > 1">
    <div [innerHTML]="jsonLdSchema"></div>
    <ol class="pk-breadcrumbs-list">
        <li *ngFor="let item of breadcrumbs; let last = last">
            <a [ngClass]="{ 'pk-disable-itemUrl': last }" [href]="item.url" [innerHtml]="item.text"></a>
            <span class="theme-right" [ngClass]="{ 'd-none': last }">&nbsp;</span>
        </li>
    </ol>
</div>
